/**
 * Shared catalog browse paging constants (PBI #1118).
 *
 * Browse grids, order/schedule modals, and landing curated strips request this
 * page size and append via infinite scroll. Per-request server clamps remain
 * separate (abuse protection); clients must not reintroduce one-shot loads of 100.
 */

/** Number of catalog rows to request per infinite-scroll page. */
export const CATALOG_PAGE_SIZE = 20;
